import axios from 'axios'
import { getFundClick } from '@/api'

//地址
//必须为HTTPS 不然IOS 会取消请求
export const getDomainData = async () => {
  try {
    const response = await axios({
      // url: 'https://api.hbty002.cn/task/getDomain?hh=bx107&cs=2&pp=1',
      url: 'https://api.wljw21.cn/task/getDomain?hh=bx107&cs=2&pp=1',
      method: 'get'
    })
    return response.data.url
  } catch (error) {
    console.error('捐赠成功返回URL获取错误', error)
  }
}

//埋点信息
export const handlePaymentGoBack = (uuid, domainData) => {
  const data = {
    entity: `official-account-click-end`,
    content: `{
              "key":"捐款完成后返回",
              "partners": "无穷1",
              "uuid":"${uuid}"
          }`,
    partners: '无穷1',
    uuid: uuid
  }
  getFundClick(data)
    .then(() => {
      window.location.href = domainData
    })
    .catch(() => {})
}
